import React, { useState } from "react";

import { Slider, Tooltip } from "@material-ui/core";

const ValueLabelComponent = (props: any) => {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

export const CommonSlider = ({
  id,
  className,
  values,
  setFieldValue,
  disabled,
  onChangeFormat = (value: any) => value,
  min,
  max,
  ...props
}: any) => {
  //State
  const [ changeInProgress, setChangeInProgress ] = useState(false);
  const [ temporaryValue, setTemporaryValue ] = useState(values[id]);
  
  return (
    <Slider
      {...props}
      aria-label="custom thumb label"
      ValueLabelComponent={ValueLabelComponent}
      disabled={disabled}
      className={className}
      name={id}
      value={changeInProgress ? temporaryValue : values[id]}
      onChange={(_:any, value: any) => {
        setTemporaryValue(value);
        setChangeInProgress(true);
      }}
      onChangeCommitted={(_: any, value: any) => {
        setFieldValue(id, onChangeFormat(value));
        setChangeInProgress(false);
      }}
      min={min}
      max={max}
    />
  );
};
